/* eslint-disable react/no-danger */
import TruckingIndustryPage from "@components/TruckingIndustryPage";
import validatePaidCampaign from "@helpers/validatePaidCampaign";
import axios from "axios";
import dynamic from "next/dynamic";
import React, { Component } from "react";
import { animateScroll as scroll } from "react-scroll";
import FooterComponent from "@/components/Footer/FooterComponent";
import Header from "@/components/Header/Header";
import SEOHead from "@/components/SEOHead/SEOHead";
import { WordPressAPI } from "../../../config";
import parse from "html-react-parser";

const FooterNewsModal = dynamic(import("@/components/FooterNewsModal"));

class TruckingIndustry extends Component {
  state = {
    isSchedulerOpen: false,
    PaidCampaign: 1,
    hideSchedulerHeader: false,
  };

  componentDidUpdate() {
    if (this.state.isSchedulerOpen) {
      document.body.classList.add("no-overflow");
    } else {
      document.body.classList.remove("no-overflow");
    }
  }

  scrollUp = () => {
    scroll.scrollToTop({
      duration: 250,
    });
  };

  toggleIsSchedulerOpen = () => {
    this.setState((prevState) => ({
      isSchedulerOpen: !prevState.isSchedulerOpen,
      hideSchedulerHeader: !prevState.isSchedulerOpen,
    }));
  };

  render() {
    const { data } = this.props;
    const { title, acf } = this.props.data;
    const paid_campaign = validatePaidCampaign(acf.paid_campaign);
    const { additional_questions } = acf;

    return (
      <div>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={
            typeof paid_campaign === "undefined" ? 1 : paid_campaign
          }
          phone_number={acf.phone_number_setup}
          leadValues={acf.lead_values}
          hideSchedulerHeader={this.state.hideSchedulerHeader}
        />
        <SEOHead>
          <title>{acf?.page_title_tag}</title>
          <meta
            name="description"
            content={acf?.meta_description || ""}
            key="description"
          />
          <script
            type="text/javascript"
            src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
          />

          {parse(`
            <script type="application/ld+json">
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "What tax deductions can a truck driver claim?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Truck drivers are eligible to claim several tax deductions, including medical, licensing, and maintenance expenses."
                }
              },{
                "@type": "Question",
                "name": "How much do owner-operators pay in taxes?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "How much owner operators have to pay in taxes depends on how their business is structured and ranges from 10% up to 37%."
                }
              }]
            }
            </script>                       
            `)}
        </SEOHead>
        <TruckingIndustryPage
          data={acf}
          isSchedulerOpen={this.state.isSchedulerOpen}
          toggleIsSchedulerOpen={this.toggleIsSchedulerOpen}
        />
        <FooterNewsModal />
        <FooterComponent phone_number={acf.phone_number_setup} />
      </div>
    );
  }
}

export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/20488`);

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default TruckingIndustry;
